import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { FormNode } from './SearchFinalForms';
import { NoForms } from './NoForms';

interface AdminDisplayFinalFormsProps {
  forms: Array<FormNode>;
  onFormClick: (formId: string) => void;
}

export const AdminDisplayFinalForms = ({
  forms,
  onFormClick,
}: AdminDisplayFinalFormsProps) => {
  if (forms.length === 0) {
    return <NoForms />;
  }

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            {[
              'ID',
              'Internal Name',
              'Business Display Name',
              'Policy Display Name',
              'Organization Name',
            ].map((header) => {
              return <TableCell key={header}>{header}</TableCell>;
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {forms.map((form) => (
            <TableRow
              key={form.id}
              onClick={() => onFormClick(form.id)}
              sx={{
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: 'action.hover',
                },
              }}
            >
              <TableCell>{form.id}</TableCell>
              <TableCell>{form.internalName ?? '-'}</TableCell>
              <TableCell>{form.businessLine?.displayName ?? '-'}</TableCell>
              <TableCell>{form.policy?.displayName ?? '-'}</TableCell>
              <TableCell>{form.organization?.name ?? '-'}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
